import { Action } from 'redux';
import { CoreCacheStatus, PriceCalculatorCacheStatus } from '../../../api/pricing/pricing.types';

export const GET_RATE_CACHE_STATUS = 'GET_RATE_CACHE_STATUS';
export const GET_CORE_CACHE_STATUS = 'GET_CORE_CACHE_STATUS';

export interface RateCacheStatusState {
  rateCacheStatus: PriceCalculatorCacheStatus | null;
  coreCacheStatus: CoreCacheStatus | null;
}

export interface GetRateCacheStatusAction extends Action {
  type: typeof GET_RATE_CACHE_STATUS;
  payload: {
    rateCacheStatus: PriceCalculatorCacheStatus | null;
  };
}

export interface GetCoreCacheStatusAction extends Action {
  type: typeof GET_CORE_CACHE_STATUS;
  payload: {
    coreCacheStatus: CoreCacheStatus | null;
  };
}

export type RatecacheStatusActionTypes = GetRateCacheStatusAction | GetCoreCacheStatusAction;
